import React, { useState } from 'react'
import Guys from '../images/guys.jpg'
import Info1 from '../images/info1.jpg'
import { IoCall } from 'react-icons/io5'
import { MdOutlineDone, MdExpandMore, MdExpandLess } from 'react-icons/md'

export default function Info() {
  const [openAccordion, setOpenAccordion] = useState(0) // Start with first item open

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? -1 : index)
  }

  const helpSections = [
    {
      title: "חיזוק התקשורת המשפחתית",
      content: "תקשורת בריאה היא הבסיס לכל משפחה מתפקדת. יחד נלמד כיצד לדבר בצורה שהילדים מקשיבים, איך לשתף רגשות בצורה בונה ואיך ליצור דיאלוג פתוח ומכבד בין כל בני המשפחה."
    },
    {
      title: "הדרכת הורים מותאמת אישית",
      content: "כל ילד הוא ייחודי ודורש גישה מותאמת. אני מביאה ניסיון עשיר מתחום חינוך הילדים כדי לעזור לכם להבין את הצרכים הייחודיים של הילדים שלכם ולפתח כלים חינוכיים יעילים ואוהבים."
    },
    {
      title: "פתרון קונפליקטים ומתחים",
      content: "כאשר יש קונפליקטים בבית, כל המשפחה סובלת. נלמד יחד איך להתמודד עם מחלוקות, איך לפתור בעיות בצורה בונה ואיך ליצור אווירה של כבוד הדדי וסבלנות."
    },
    {
      title: "הצבת גבולות בריאים",
      content: "גבולות ברורים ועקביים יוצרים תחושת ביטחון לילדים ושלווה להורים. נעבוד יחד על הצבת גבולות אפקטיביים שמתאימים לגיל ולאופי של כל ילד, תוך שמירה על חיבור אוהב."
    },
    {
      title: "בניית אווירה משפחתית חיובית",
      content: "משפחה היא הבסיס הרגשי שלנו. נלמד איך ליצור מסורות משפחתיות משמעותיות, איך לחגוג את הקטן והגדול ואיך להפוך את הבית למקום שכולם רוצים לחזור אליו."
    },
    {
      title: "תמיכה במעברי חיים",
      content: "גירושין, לידה של אח חדש, מעבר דירה או כל שינוי משמעותי יכולים להשפיע על המשפחה. אני כאן כדי ללוות אתכם במעברים האלו ולעזור לכם להתמודד עם האתגרים בצורה מחזקת."
    }
  ]

  return (
    <div id="info" className="p-4 bg-brown py-8 rounded-t-3xl pb-12">
      <h1 dir="rtl" className="text-5xl md:text-6xl text-center text-primary font-extrabold mt-2">
        ייעוץ משפחתי
      </h1>
      <h2 dir="rtl" className="text-3xl md:text-4xl text-center text-primary font-bold mt-4">
        ליצור בית חם ואוהב, לחזק את הקשרים המשפחתיים ולבנות תקשורת בריאה
      </h2>
      <div
        dir="rtl"
        className="mt-16 bg-card text-white leading-8 md:text-3xl text-center max-w-[1200px] mx-auto px-6 bg-brown-800 rounded-3xl shadow-2xl p-8 border-4 border-[#e6dbc9]"
      >
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-white">האם אתם מרגישים כך?</h2>
        <ul className="list-none space-y-6 mb-8 font-medium">
          <li className="bg-brown text-primary p-4 rounded-xl shadow-md hover:bg-brown-600 transition-colors duration-300">
            "קשה לנו לתקשר עם הילדים ולהבין איך להגיב נכון."
          </li>
          <li className="bg-brown p-4 text-primary  rounded-xl shadow-md hover:bg-brown-600 transition-colors duration-300">
            "יש מתחים בבית ואנחנו לא יודעים איך להתמודד עם קונפליקטים."
          </li>
          <li className="bg-brown p-4 text-primary rounded-xl shadow-md hover:bg-brown-600 transition-colors duration-300">
            "הילדים לא מקשיבים ואנחנו מרגישים חסרי אונים."
          </li>
        </ul>
        <p className="mb-8 text-xl md:text-2xl">
          אם המשפטים האלו נשמעים לכם מוכרים, אתם לא לבד. רבות ממשפחות מתמודדות עם אתגרים דומים. החיים המהירים, הלחצים והאתגרים החינוכיים יכולים ליצור תחושה של חוסר שליטה ועייפות.
        </p>
        <p className="text-2xl md:text-3xl font-bold text-[#e6dbc9]">אני כאן כדי להראות לכם שאפשר אחרת.</p>
      </div>

      <div className="mt-12 max-w-[1000px] rounded-3xl shadow-2xl mx-auto relative overflow-hidden">
        {/* Background image with overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${Guys})`,
          }}
        />
        <div className="absolute inset-0 bg-black bg-opacity-60" />
        
        {/* Content over background */}
        <div dir="rtl" className="relative z-10 px-4 m-4 md:m-8 mb-8 py-8">
          <h1 className="text-[#e6dbc9] text-center font-extrabold text-3xl md:text-4xl mt-4 mb-6">
            איך אני יכולה לעזור לכם?
          </h1>

          <div className="space-y-4">
            {helpSections.map((section, index) => (
              <div 
                key={index} 
                className="bg-white bg-opacity-10 rounded-xl shadow-lg backdrop-blur-sm border border-white border-opacity-20"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-6 py-4 text-right flex items-center justify-between hover:bg-white hover:bg-opacity-5 transition-all duration-300 rounded-xl"
                >
                  <h3 className="text-xl md:text-2xl font-bold text-[#e6dbc9]">
                    {section.title}
                  </h3>
                  <div className="flex items-center">
                    {openAccordion === index ? (
                      <MdExpandLess className="text-2xl text-[#e6dbc9] mr-2" />
                    ) : (
                      <MdExpandMore className="text-2xl text-[#e6dbc9] mr-2" />
                    )}
                  </div>
                </button>
                
                <div 
                  className={`overflow-hidden transition-all duration-500 ease-in-out ${
                    openAccordion === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-4">
                    <p className="text-white text-lg md:text-xl leading-relaxed">
                      {section.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-12 max-w-[800px] bg-white py-8 px-6 rounded-3xl shadow-2xl mx-auto">
        <div dir="rtl" className="px-4 mx-auto justify-center flex flex-col items-center m-4 md:m-8">
          <h1 className="text-primary text-center font-extrabold text-3xl md:text-4xl mt-4">למה דווקא אני?</h1>
          <ul className="mx-auto text-right md:text-xl text-black mt-4">
          
            <li className="mt-4">
              <span className="font-bold">גישה הוליסטית:</span> אני מתייחסת למשפחה כמערכת שלמה ועוזרת לכל בן משפחה למצוא את מקומו בצורה בריאה ואוהבת.
            </li>
            <li className="mt-4">
              <span className="font-bold">כלים מעשיים:</span> אני מעניקה כלים קונקרטיים שאפשר ליישם מיד בבית, לא רק תיאוריה אלא פתרונות שעובדים באמת.
            </li>
            <li className="mt-4">
              <span className="font-bold">ליווי אישי ורגיש:</span> אני מבינה שכל משפחה היא עולם שלם ואני כאן כדי ללוות אתכם בחמלה ובהבנה.
            </li>
          </ul>
        </div>
      </div>

      <img
        alt="dd"
        src={Info1 || '/placeholder.svg'}
        className="md:max-w-[500px] border-8 border-white shadow-2xl object-contain hover:scale-105 duration-300 mx-auto m-4 my-16 rounded-3xl"
      />

      <h1 dir="rtl" className="text-4xl md:text-5xl text-center text-primary font-extrabold my-8">
        מה אומרות משפחות שעברו תהליך?
      </h1>
      <div dir="rtl" className="text-black leading-7 md:text-xl text-center max-w-[1000px] mx-auto px-4">
        <div className="space-y-8">
          <blockquote className="bg-brown-800 p-6 rounded-xl shadow-lg italic">
            'היי מלי, הגענו אלייך כדי "לנער את הסדינים", להתייחס לדברים שמפריעים לנו אחד בשנייה בנוגע לזוגיות ולהורות שלנו. בטיפול פתחנו בפנייך נושאים שמעכבים ומורידים אותנו ולמדנו איך אפשר לקבל, להתמודד, להודות, לוותר ולא להתפשר על מה שצריך. המפגשים השפיעו על ההתנהלות בבית עם הילדים, הצבת גבולות והכי חשוב שכדי לקבל זכויות עליהם ללמוד שיש חובות. הבנות לוקחות חלק פעיל בבית ואני למדתי לשחרר בעיקר בחדרים שלהן ולתת לעצמי יותר זמן של שקט ורוגע.'
          </blockquote>

          <blockquote className="bg-brown-800 p-6 rounded-xl shadow-lg italic">
            'היי מלי, אני אומרת כמעט כל יום שאשלח לך הודעה. מאז שהסברת לבעלי על הילדה, ועל זה שאם הוא יגיד שהיא ילדה בעייתית והשניה ילדה טובה, הוא השתנה פלאים. אמאלה כמה הם מסתדרים עכשיו יש לי אוויר אני יכולה ללכת למקומות מבלי לחשוש, הוא איתה בכיף ובשמחה, וגם היא! אז תודה לך. זה שווה עולם🩷😘'
          </blockquote>
        </div>
      </div>

      <p dir="rtl" className="text-xl md:text-2xl text-center text-primary font-bold  mt-4 max-w-[800px] mx-auto">
        אם אתם מרגישים שהקשר של משפחתכם יכול להיות טוב יותר – זה הזמן לפעול. אל תוותרו על החיבור ועל האהבה שיכולים להיות חלק בלתי נפרד מהחיים שלכם.
      </p>

      <div className="flex justify-center my-12 text-primary ">
        <a
          href="tel:+972509933553"
          className="bg-card text-white text-center flex justify-center items-center from-primary m-2 border-2 shadow-2xl to-secondary px-10 py-4 text-lg font-extrabold rounded-full hover:scale-105 duration-300"
        >
          <IoCall className="text-4xl mr-4" />
          <span className="text-lg md:text-xl"> לשיחת ייעוץ ראשונית ללא עלות</span>
        </a>
      </div>
    </div>
  )
}
